import { Grid } from "@mui/material";
import { FunctionField, Labeled, ReferenceField, TextField, useRecordContext } from "react-admin";
import { administrationRequests } from "api/administrationApi";

const Citizenship = () => {
  const record = useRecordContext();
  if (!record?.candidate) return null;

  const { primaryCitizenshipCountryId, secondaryCitizenshipCountryId, residenceCountryId } =
    record.candidate;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <Labeled label="Държава на пребиваване">
          {residenceCountryId ? (
            <ReferenceField
              source="candidate.residenceCountryId"
              reference={administrationRequests.getCountriesSelect()}
              link={false}
            >
              <TextField source="nameBg" />
            </ReferenceField>
          ) : (
            <FunctionField render={() => "—"} />
          )}
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Първо гражданство">
          {primaryCitizenshipCountryId ? (
            <ReferenceField
              source="candidate.primaryCitizenshipCountryId"
              reference={administrationRequests.getCountriesSelect()}
              link={false}
            >
              <TextField source="nameBg" />
            </ReferenceField>
          ) : (
            <FunctionField render={() => "—"} />
          )}
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Второ гражданство">
          {secondaryCitizenshipCountryId ? (
            <ReferenceField
              source="candidate.secondaryCitizenshipCountryId"
              reference={administrationRequests.getCountriesSelect()}
              link={false}
            >
              <TextField source="nameBg" />
            </ReferenceField>
          ) : (
            <FunctionField render={() => "—"} />
          )}
        </Labeled>
      </Grid>
    </Grid>
  );
};

export default Citizenship;
